import React from 'react'

const MenteeDashboard = () => {
  return (
    <div>MenteeDashboard</div>
  )
}

export default MenteeDashboard